import { useSSRContext } from '@/ssr-context';
import { env } from '@/utils/env';
import { useEffect, useState } from 'react';

export function useMediaQueryMatches(query: string) {
  const [matches, setMatches] = useState(
    () => !env.isSSR() && matchMedia(query).matches,
  );

  useEffect(() => {
    if (env.isSSR()) return;

    const unsubscribe = matchMedia(query).addEventListener('change', (e) => {
      setMatches(e.matches);
    });
    return unsubscribe;
  }, []);

  return matches;
}

const MOBILE_QUERY = '(max-width: 480px)';
export function useIsMobile() {
  const ssr = useSSRContext();
  return (ssr.isSSR && ssr.isUAMobile) || useMediaQueryMatches(MOBILE_QUERY);
}

const MOBILE_TABLET_QUERY = '(max-width: 1100px)';
export function useIsMobileOrTablet() {
  const ssr = useSSRContext();
  return (
    (ssr.isSSR && ssr.isUAMobile) || useMediaQueryMatches(MOBILE_TABLET_QUERY)
  );
}

const LANDSCAPE_QUERY = '(@media only screen and (orientation:landscape))';
export function useIsLandscape() {
  return useMediaQueryMatches(LANDSCAPE_QUERY);
}
